import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
/**
 * Service that controls side menu appearance
 */
export class SidenavService {
  public sideNavToggleSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  /**
   * Toggles sidenav
   * @return {any}
   */
  public toggle() {
    return this.sideNavToggleSubject.next(null);
  }
}
